import styled from "styled-components";
import BookSpaceForm from "../../components/BookSpaceForm/BookSpaceForm";

const BookASpaceContainer = styled.div`
  min-height: 100vh;
  padding-top: 90px; /* Add padding to push contact card down below navigation */
  background: #101015;
  
  @media (max-width: 768px) {
    padding-top: 100px; /* Less padding on mobile */
  }
`;

export default function BookASpace() {
  return (
    <BookASpaceContainer>
      <BookSpaceForm />
    </BookASpaceContainer>
  );
}